import React, { Component } from 'react';

import { observer } from 'mobx-react';
import Select from 'react-select';

@observer
class SelectComponent extends Component {
  onChange(props, value) {
    const { onChangeCustomComponent, name } = props.input;
    const { values } = props.meta;
    onChangeCustomComponent(value && value.value, name);
    props.selectStore.onChangeSelect(value && value.value, name, values);
  }

  componentWillUpdate(nextProps) {
    const options = nextProps.selectStore[nextProps.optionsName];

    if (!options || !options.length) {
      this.onChange(nextProps, null);
    }
  }

  render() {
    const props = this.props;

    const { value, name } = props.input;
    const { optionsName, loadingFlagName } = props;

    return (
      <Select
        className="tpi-select"
        name={name}
        value={value}
        onChange={this.onChange.bind(this, props)}
        options={props.selectStore[optionsName]}
        isLoading={loadingFlagName && props.selectStore[loadingFlagName]}
        disabled={props.isSelectFieldDisabled()}
      />
    );
  }
}

export default SelectComponent;



// WEBPACK FOOTER //
// ./src/common/components/fields/SelectField.jsx